module.exports = __webpack_public_path__ + "img/cart.e0ad1abb.svg";